export default {
    data() {
        return {
            usbCmd: {
                // <<COMMANDLIST START>>
                ERROR_RESPONSE : 0,
                GET_MEASUREMENT : 1,
                GET_BUILD_TIMESTAMP : 2,
                GET_CALIBRATION_READING : 3,
                // <<COMMANDLIST END>>
            },

        }
    },
}
